document.addEventListener("DOMContentLoaded", () => {
  const tabSections = document.querySelectorAll(`.js-tab-section`);

  tabSections.forEach((section) => {
    const tabItems = section.querySelectorAll(`.js-tab-item`);

    tabItems.forEach((tab) => {
      tab.addEventListener("click", (e) => {
        // if clicked tab is active
        if (tab.classList.contains("active")) return;

        const tabId = tab.getAttribute("data-tab-id");

        // Remove active classes from currently active elements
        const oldActiveTab = section.querySelector(".js-tab-item.active");
        const oldActiveContent = section.querySelector(
          ".js-tab-content.active"
        );

        oldActiveTab?.classList.remove("active");
        oldActiveContent?.classList.remove("active");

        // Add active class to clicked tab
        tab.classList.add("active");

        // Efficient query: select tab content with matching data-tab-id
        const newTabContent = section.querySelector(
          `.js-tab-content[data-tab-id="${tabId}"]`
        );
        newTabContent?.classList.add("active");
      });
    });
  });
});
